const THEME_KEY = 'app-theme';

function getSystemTheme() {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getStoredTheme() {
  if (typeof localStorage === 'undefined') return 'system';
  return localStorage.getItem(THEME_KEY) || 'system';
}

export function getEffectiveTheme() {
  const stored = getStoredTheme();
  if (stored === 'system') {
    return getSystemTheme();
  }
  return stored;
}

export function applyTheme(theme) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme);
    const metaThemeColor = document.getElementById('theme-color-meta');
    if (metaThemeColor) {
      metaThemeColor.content = theme === 'dark' ? '#18181b' : '#B8860B';
    }
  }
}

export function initTheme() {
  const theme = getEffectiveTheme();
  applyTheme(theme);

  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const handleChange = () => {
    if (getStoredTheme() === 'system') {
      const systemTheme = getSystemTheme();
      applyTheme(systemTheme);
      syncNativeUI(systemTheme);
    }
  };

  if (mq.addEventListener) {
    mq.addEventListener('change', handleChange);
  } else if (mq.addListener) {
    mq.addListener(handleChange);
  }
}

export async function setTheme(mode) {
  if (!['light', 'dark', 'system'].includes(mode)) return;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(THEME_KEY, mode);
  }
  const theme = getEffectiveTheme();
  applyTheme(theme);
  await syncNativeUI(theme);
}

async function syncNativeUI(theme) {
  if (typeof window === 'undefined' || !window.Capacitor?.isNativePlatform?.()) return;
  try {
    const StatusBar = window.Capacitor?.Plugins?.StatusBar;
    if (!StatusBar) return;
    if (theme === 'dark') {
      await StatusBar.setStyle({ style: 1 });
      await StatusBar.setBackgroundColor({ color: '#18181b' });
    } else {
      await StatusBar.setStyle({ style: 0 });
      await StatusBar.setBackgroundColor({ color: '#B8860B' });
    }
  } catch (e) {
    console.warn('Native theme sync failed', e);
  }
}
